module.exports = __webpack_public_path__ + "img/manage_history.3af02bf9.svg";